/** e.g. "legal-information" → "Legal Information" */
export function formatMentionDisplayName(name: string): string {
  return name
    .split(/[-_]/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}
